/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Billing_DescriptionInputs */

const en_marketing_feature_billing_description = /** @type {(inputs: Marketing_Feature_Billing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe subscriptions per organization: per-seat pricing and plan guards at every layer.`)
};

const es_marketing_feature_billing_description = /** @type {(inputs: Marketing_Feature_Billing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripciones de Stripe por organización: precio por asiento y controles de plan en cada capa.`)
};

const fr_marketing_feature_billing_description = /** @type {(inputs: Marketing_Feature_Billing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnements Stripe par organisation : tarification par siège et garde-fous de plan à chaque couche.`)
};

/**
* | output |
* | --- |
* | "Stripe subscriptions per organization: per-seat pricing and plan guards at every layer." |
*
* @param {Marketing_Feature_Billing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_billing_description = /** @type {((inputs?: Marketing_Feature_Billing_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Billing_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_billing_description(inputs)
	if (locale === "es") return es_marketing_feature_billing_description(inputs)
	return fr_marketing_feature_billing_description(inputs)
});